import BoundaryError from 'common/components/BoundaryError'
import ApplicationConf from 'conf/ApplicationConf'
import { fetchCustomers } from 'gdl/customers/CustomersSlice'
import { fetchInstances } from 'supervision/instances/InstancesSlice'
import NavBar from 'common/components/NavBar'
import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { Outlet, useLocation, useParams } from 'react-router'
import useFetch from 'common/hooks/useFetch'
import { fetchCommercialFeatures } from 'gdl/commercial/commercialFeature/CommercialFeaturesSlice'
import { LicensesActions } from '../licenses/LicensesSlice'

const CustomerApp = () => {
    const { id } = useParams()
    const { pathname } = useLocation()
    const dispatch = useDispatch()

    const {
        data: customer,
        reload: reloadCustomer,
    } = useFetch(ApplicationConf.gdl.customer(id))

    const {
        data: notes,
        reload: reloadNotes,
    } = useFetch(ApplicationConf.gdl.customerNotes(id))

    // Chargements différés : on attend que la fiche (customer + notes) soit chargée avant de lancer
    // les appels secondaires plus lourds (projets, synthèse licences, features), pour que la fiche
    // s'affiche vite sans être ralentie par la saturation du pool de connexions.
    const customerLoaded = Boolean(customer)

    const {
        data: projects = [],
    } = useFetch(customerLoaded ? ApplicationConf.support.projects() : undefined)

    // Les instances servent aux libellés de la fiche : chargées tout de suite.
    useEffect(() => {
        dispatch(fetchInstances())
    }, [dispatch])

    useEffect(() => {
        if (!customerLoaded) {
            return
        }
        dispatch(fetchCustomers())
        dispatch(fetchCommercialFeatures())
        dispatch(LicensesActions.fetchLicensesSyntesis(id))
    }, [dispatch, id, customerLoaded])

    const links = [
        { icon: 'dashboard', tooltip: 'Dashboard', url: `/customer/${id}/dashboard` },
        { icon: 'event_note', tooltip: 'Notes', url: `/customer/${id}/notes` },
        { icon: 'confirmation_number', tooltip: 'Tickets', url: `/customer/${id}/tickets` },
        { icon: 'inventory_2', tooltip: 'Lots', url: `/customer/${id}/lots` },
        { icon: 'lightbulb', tooltip: 'Idées', url: `/customer/${id}/ideas` },
    ]
    return (
        <>
            <NavBar links={links} />
            <BoundaryError url={pathname}>
                <div style={{ marginLeft: '65px' }}>
                    <Outlet
                        context={{
                            customer, reloadCustomer,
                            notes, reloadNotes,
                            projects,
                        }}
                    />
                </div>
            </BoundaryError>
        </>
    )
}

export default CustomerApp